import { render, staticRenderFns } from "./CafeCategory.vue?vue&type=template&id=617be78c&scoped=true&"
import script from "./CafeCategory.vue?vue&type=script&lang=js&"
export * from "./CafeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617be78c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('617be78c', component.options)
    } else {
      api.reload('617be78c', component.options)
    }
    module.hot.accept("./CafeCategory.vue?vue&type=template&id=617be78c&scoped=true&", function () {
      api.rerender('617be78c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/CafeCategory.vue"
export default component.exports